export default (element, method, parameters) => {
    if (!element || !element[method]) {
        return;
    }

    element[method].apply(null, parameters);
};
